import { type Validation } from "@common/controls/Form/component";
import { type OptionItem } from "@common/declarations";
import { ethereumValidator, tronValidator } from "@common/lib/validate";

export const getDefaultValue = (json: string | null): string | null => {
  if (!json) return null;

  const options = getOptions(json);
  return options.length > 1 ? null : options[0].value;
};

export const getOptions = (json: string | null): OptionItem<string>[] => {
  if (!json) return [];
  if (!json.startsWith("[")) return [{ label: json, value: json }]; // not a JSON?
  return JSON.parse(json).map((x) => ({ label: x, value: x }));
};

export const getCryptoValidation = (blockchainNetwork: string): Validation | undefined => {
  switch (blockchainNetwork) {
    case "Ethereum":
      return ethereumValidator;
    case "Tron":
      return tronValidator;
    default:
      return;
  }
};
